import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';

export const intensityDenominatorMonetaryMetadata = {
  displayName: msg({
    message: 'Income',
    context: 'Activity data schema name for income',
  }),
  fields: {
    ...coreFields,
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Quantity of currency',
        context: 'The quantity of currency.',
      }),
    },
    intensity_denominator_kind: {
      displayName: msg({
        message: 'Intensity denominator kind',
        context: 'The display name for intensity_denominator_kind field',
      }),
      externalDescription: msg({
        message: 'The kind of intensity denominator.',
        context: 'Intensity denominator kind',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
